<template>
    <div class="s-que">
        <manage-title>试题管理</manage-title>
        <!-- 筛选条件 -->
        <div class="s-condition xy-between flex-wrap">
            <div class="xy-center jf-start item">
                <!-- <div class="name">分类</div> -->
                <medical-class-selector
                    ref="select"
                    v-model="queInfo.type"
                    clearable
                    style="width:150px"
                ></medical-class-selector>
            </div>
            <div class="xy-center jf-start item">
                <!-- <div class="name">题型</div> -->
                <el-select
                    v-model="queInfo.queType"
                    placeholder="题型"
                    clearable
                    style="width:150px"
                >
                    <el-option
                        v-for="item in queTypeData"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class="xy-center jf-start item">
                <!-- <div class="name">状态</div> -->
                <el-select
                    v-model="queInfo.state"
                    placeholder="试题状态"
                    clearable
                >
                    <el-option
                        v-for="item in stateData"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class="xy-center jf-start item">
                <!-- <div class="name">难易程度</div> -->
                <el-select
                    v-model="queInfo.difficulty"
                    placeholder="试题难易度"
                    clearable
                >
                    <el-option
                        v-for="item in difficultyData"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class="xy-center jf-start item">
                <!-- <div class="name">试题用途</div> -->
                <el-select
                    v-model="queInfo.useFor"
                    placeholder="用途"
                    clearable
                >
                    <el-option
                        v-for="item in useForData"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div>

            <div class="xy-start search item">
                <el-input
                    v-model="queInfo.searchKey"
                    placeholder="请输入关键字检索..."
                    style="margin-right: -15px"
                    @keyup.enter.native="fetchQue(true);"
                ></el-input>
                <el-button
                    class="button"
                    type="primary"
                    style="z-index: 10"
                    @click="fetchQue(true)"
                    >检索</el-button
                >
            </div>
        </div>
        <div class="xy-center jf-end s-options">
            <el-button type="primary" @click="addNewQue">新增试题 </el-button>
            <el-button type="primary" @click.stop="handleImport">批量导入 </el-button>
            <el-button type="primary" @click.stop="handleExport">批量导出 </el-button>
            <el-button type="primary" v-if="this.multipleSelection.length === 0" @click="batchDelete">批量删除</el-button>
            <el-popconfirm title="确定批量删除吗？" @confirm="batchDelete" v-else>
                <el-button type="primary" slot="reference" class="margin-left-xs">批量删除</el-button>
            </el-popconfirm>
        </div>

        <div style="padding: 0 30px">
            <el-table
                :data="tableData"
                border
                class="el-table"
                @selection-change="handleSelectionChange"
                v-loading="flag.loading"
            >
                <el-table-column type="selection" width="50" align="center">
                </el-table-column>
                <el-table-column
                    label="序号"
                    type="index"
                    width="50"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="SubjectName"
                    label="试题"
                    show-overflow-tooltip
                >
                    <template slot-scope="scoped">
                        <table-que
                            :data="scoped.row.SubjectDetails"
                        ></table-que>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="ClassId"
                    label="所属分类"
                    width="100"
                    align="center"
                >
                    <template v-slot="scoped">
                        <div>
                            {{
                                (
                                    organClass.find(
                                        (item) =>
                                            item.value ===
                                            parseInt(scoped.row.ClassId)
                                    ) || {}
                                ).label
                            }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="SubjectState"
                    label="状态"
                    width="50"
                    align="center"
                >
                    <template v-slot="scoped">
                        <div>
                            {{
                                (
                                    stateData.find(
                                        (item) =>
                                            item.value ===
                                            parseInt(scoped.row.SubjectState)
                                    ) || {}
                                ).name
                            }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="UseType"
                    label="用途"
                    width="70"
                    align="center"
                >
                    <template v-slot="scoped">
                        <div>
                            {{
                                (
                                    useForData.find(
                                        (item) =>
                                            item.value ===
                                            parseInt(scoped.row.UseType)
                                    ) || {}
                                ).name
                            }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="JoinExamNum"
                    label="组卷数"
                    width="70"
                    align="center"
                >
                    <template v-slot="scoped">
                        <div>{{ scoped.row.JoinExamNum || 0 }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="AddUserName"
                    label="创建人"
                    width="70"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="AddTime"
                    label="创建时间"
                    width="100"
                    align="center"
                >
                    <template v-slot="scoped"
                        >{{ (scoped.row.AddTime || "").substring(0, 10) }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="180"
                    class-name="options-btn"
                    align="center"
                >
                    <template v-slot="scoped">
                        <el-button
                            size="mini"
                            @click="handleEdit(scoped.$index, scoped.row)"
                            plain
                            >编辑</el-button
                        >
                        <el-popconfirm
                            title="确定删除试题吗？"
                            @confirm="handleDelete(scoped.$index, scoped.row)"
                        >
                            <el-button
                                slot="reference"
                                size="mini"
                                type="danger"
                                :disabled="scoped.row.JoinExamNum > 0"
                                plain
                                >删除</el-button
                            >
                        </el-popconfirm>

                        <el-button
                            size="mini"
                            type="success"
                            @click="handleState(scoped.$index, scoped.row)"
                            plain
                            >{{
                                !parseInt(scoped.row.SubjectState)
                                    ? "启用"
                                    : "禁用"
                            }}</el-button
                        >
                    </template></el-table-column
                ></el-table
            >
        </div>

        <div class="pagination xy-center mt-15">
            <el-pagination
                hide-on-single-page
                @current-change="handleCurrentChange"
                @size-change="fetchQue(true)"
                :current-page.sync="currentPage"
                :page-size.sync="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
            >
            </el-pagination>
        </div>
        <el-dialog
            title="编辑试题"
            :visible.sync="editDialog"
            width="1100px"
            @open="loadQueDetails"
            @closed="clearEdit"
            destroy-on-close
            custom-class="edit-dialog m-dialog"
            :lock-scroll="false"
        >
            <div class="xy-start s-condition">
                <div class="xy-center jf-start item">
                    <div class="name">分类</div>
                    <medical-class-selector
                        v-model="activeQue.ClassId"
                        :add-all="false"
                    ></medical-class-selector>
                </div>
                <div class="xy-center jf-start item">
                    <div class="name">状态</div>
                    <el-select
                        v-model="activeQue.SubjectState"
                        placeholder="请选择"
                        clearable
                    >
                        <el-option
                            v-for="item in stateData"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="xy-center jf-start item">
                    <div class="name">难易程度</div>
                    <el-select
                        v-model="activeQue.Hardlevel"
                        placeholder="请选择"
                        clearable
                    >
                        <el-option
                            v-for="item in difficultyData"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="xy-center jf-start item">
                    <div class="name">试题用途</div>
                    <el-select
                        v-model="activeQue.UseType"
                        placeholder="请选择"
                        clearable
                    >
                        <el-option
                            v-for="item in useForData"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="xy-center jf-start item">
                    <div class="name">知识点:</div>
                    <el-select
                        v-model="activeQue.KnowledgePoint"
                        placeholder="请选择"
                        clearable
                    >
                        <el-option
                            v-for="item in organInfo"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                            <div
                                :style="{
                                        paddingLeft: `${
                                            item.parentIds.length * 20
                                        }px`,
                                    }"
                            >
                                {{ item.label }}
                            </div>
                        </el-option>
                    </el-select>
                </div>
            </div>
            <add-que-box
                ref="editBox"
                :que-type="activeQue.SubjectType"
                :edit-que-data="activeQue"
            ></add-que-box>
            <span slot="footer" class="xy-center">
                <el-button @click="editDialog = false">取 消</el-button>
                <el-button type="primary" @click="confirmUpdate"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
        <question-template ref="questionTemplate" @updateList="onUpdateList"/>
    </div>
</template>

<script>
import {
    fetchQueList,
    deleteQue,
    fetchQueDetails,
    updateQue,
    exportQuestions
} from "@/api/manage";
import MedicalClassSelector from "@/components/manager/MedicalClassSelector";
import questionTemplate from "./question-cpns/question-template";
import { CommonPage } from "@/mixins/commonData";
import AddQueBox from "../../../components/manager/resource/AddQueBox.vue";
import tableQue from "../../../components/manager/resource/tableQue.vue";
import ManageTitle from "@/components/manager/ManageTitle";
import { GetOrganPointInfo } from "@/api/category";
import QuestionHelp from "@/mixins/questionHelp"
import { uuid } from "@/utils";
import { downloadUrl } from "download.js";

export default {
    components: { ManageTitle, AddQueBox, tableQue, MedicalClassSelector, questionTemplate },
    mixins: [CommonPage, QuestionHelp],
    data() {
        return {
            queInfo: {
                type: "",
                state: "",
                useFor: "",
                searchKey: "",
                queType: "",
                difficulty: ""
            },
            flag: {
                loading: false
            },
            organInfo: [],
            multipleSelection: [],
            totalCount: 0,
            currentPage: 1,
            pageSize: 10,
            tableData: [],
            editDialog: false,
            activeQue: {}
        };
    },
    watch: {
        queInfo: {
            handler: function(vl, ovl) {
                if (vl.searchKey !== (this.searchKey || "")) {
                    this.searchKey = vl.searchKey;
                    return;
                }
                this.fetchQue(true);
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {
        this.fetchOrganClass();
        this.fetchQue();
    },
    computed: {
        organClass() {
            let data = this.$refs.select.categories.slice(1);
            let newData = [];
            const work = (vl, pIds) => {
                for (let i = 0; i < vl.length; i++) {
                    newData.push({
                        label: vl[i].ClassName,
                        value: vl[i].ClassId,
                        parentIds: pIds
                    });
                    if (vl[i] && vl[i].children && vl[i].children.length) {
                        work(vl[i].children, pIds.concat([vl[i].ClassId]));
                    }
                }
            };
            if (data.length > 0) {
                work(data, []);
            }

            // console.log("newData:", newData);
            return newData || [];
        }
    },
    methods: {
        handleImport () {
            this.$refs.questionTemplate.open()
        },
        fetchOrganClass() {
            const work = (newData, vl, pIds) => {
                for (let i = 0; i < vl.length; i++) {
                    newData.push({
                        label: vl[i].KnowledgePointName,
                        value: vl[i].Id,
                        parentIds: pIds,
                    });
                    // console.log("vl[i]:", vl[i]);
                    if (vl[i].children.length) {
                        work(
                            newData,
                            vl[i].children,
                            pIds.concat([vl[i].Id])
                        );
                    }
                }
            };
            GetOrganPointInfo().then((res) => {
                let newData = [];
                work(newData, res.data.data, []);
                this.organInfo = newData;
                // console.log("res:", res);
            });
        },
        fetchQue(refresh) {
            if (refresh === true) {
                this.currentPage = 1;
            }
            this.flagPromise([
                fetchQueList({
                    classId: this.queInfo.type,
                    subjectType: this.queInfo.queType,
                    subjectState: this.queInfo.state,
                    hardLevel: this.queInfo.difficulty,
                    subjectUse: this.queInfo.useFor,
                    searchKey: this.queInfo.searchKey,
                    pageNo: this.currentPage,
                    pageSize: this.pageSize
                })
            ]).then(([res]) => {
                // console.log(data);
                this.totalCount = res.data.count;
                this.tableData = res.data.data;
            });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.fetchQue();
        },
        handleEdit(index, row) {
            this.activeQue = {
                SubjectId: row.SubjectId
            };
            this.editDialog = true;

            // console.log(index, row);
        },
        handleState(index, row) {
            const state = parseInt(row.SubjectState);
            deleteQue({
                ids: row.SubjectId,
                state: !state ? 1 : 0
            }).then((res) => {
                this.fetchQue();
                this.$message.success("已" + (!state ? "启用" : "禁用"));
            });
        },
        handleDelete(index, row) {
            const data = Array.isArray(row)
                ? row.map((v) => v.SubjectId).join(",")
                : row.SubjectId;
            deleteQue({ ids: data, state: -1 }).then((res) => {
                if (this.needToPrePage({
                    page: this.currentPage,
                    pageSize: this.pageSize,
                    total: this.totalCount,
                    delCount: data.split(",").length
                })) {
                    this.currentPage--
                }
                this.$message.success("成功删除");
                this.fetchQue();
            }).catch(e => {
                if (e.data === false) {
                    this.$message.error(e.msg)
                }
            });
        },
        batchDelete() {
            if (!this.multipleSelection.length) {
                this.$message.warning("暂无选中数据");
                return;
            }
            this.handleDelete(0, this.multipleSelection);
        },

        addNewQue() {
            this.$router.push("/manage/resource/addQue");
        },
        loadQueDetails() {
            fetchQueDetails({ id: this.activeQue.SubjectId }).then((res) => {
                this.activeQue = res;
                let d = this.activeQue.AnswerList?.forEach(el => {
                    el.uuid = uuid(5)
                })
                if (this.activeQue.KnowledgePoint) {
                    this.activeQue.KnowledgePoint = parseInt(this.activeQue.KnowledgePoint)
                }
            });
        },
        // 清理试题编辑数据
        clearEdit() {
            this.activeQue = {}
        },
        confirmUpdate() {
            let newQue = this.$refs.editBox.queData;
            let msg = this.verifyQues(newQue)
            if (msg) {
                this.$message.warning(msg)
                return
            }
            newQue = Object.assign({}, newQue)
            newQue.SubjectName = newQue.Content;
            if (Array.isArray(newQue.Answer)) {
                newQue.Answer = newQue.Answer.join(",")
            }
            updateQue({ examSubjectModel: JSON.stringify(newQue) }).then(
                (res) => {
                    this.editDialog = false;
                    this.$message.success("修改成功");
                    this.fetchQue();
                }
            );
        },
        handleExport () {
            if (this.multipleSelection.length === 0) {
                this.$message.warning("请选择试题");
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: "导出中",
                background: "rgba(0, 0, 0, .2)"
            });
            exportQuestions(this.multipleSelection.map(item => item.SubjectId).join()).then(res => {
                loading.close()
                downloadUrl("", res)
            }).catch(e => {
                loading.close()
            })
        },
        onUpdateList () {
            this.fetchQue()
        }
    }
};
</script>

<style lang="less" scoped>
.s-que::v-deep {
    .s-condition {
        padding: 0 30px;
        .item {
            margin-top: 20px;
            .name {
                white-space: nowrap;
                font-size: 16px;
                margin-right: 5px;
            }
        }
        .el-input {
            width: 120px;
            height: 34px;
            input {
                height: 34px;
                ::placeholder {
                    font-size: 16px;
                }
            }
        }
        .search {
            .el-button {
                margin-left: 10px;
                width: 60px;
                height: 34px;
                padding: 0;
                border-radius: 4px;
            }
            .el-input {
                width: 150px;
            }
        }
    }
    .s-options {
        padding: 0 30px;
        margin-top: 30px;
        .el-button {
            width: 90px;
            height: 34px;
            padding: 0;
            border-radius: 4px;
        }
    }
    .el-table {
        margin-top: 20px;
        .options-btn {
            .el-button {
                width: 40px;
                padding: 5px 2px;
            }
            .el-button:nth-of-type(1) {
                margin-right: 5px;
            }
            .el-button:nth-of-type(2) {
                margin-left: 5px;
            }
        }
    }
    .pagination {
        margin: 20px 0 30px;
    }
    .edit-dialog {
        min-height: 50vh;
        .s-condition {
            margin-bottom: 60px;
            padding: 0 42px;
            .item {
                margin-right: 30px;
            }
        }
    }
}
.margin-left-xs {
    margin-left: 10px;
}
</style>
